import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-payment-verification-branch',
  templateUrl: './payment-verification-branch.component.html',
  styleUrls: ['./payment-verification-branch.component.scss']
})
export class PaymentVerificationBranchComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
